export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14336.1f409135.jpg";